import React from 'react'
import { useState } from 'react'
import ValueWithEdit from '../../../../UI/table/values/ValueWithEdit'
import MyModal from '../../../../UI/modal/MyModal'
import ChangeNakladnaForm from './ChangeNakladnaForm'

const ChangeNakladnaButton = ({ supplyBill }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <ValueWithEdit
            value={supplyBill.isNakladna ? 'Так' : 'Ні'}
            textTooltip={'Редагувати'}
            setOpen={setOpen}
        />

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Редагування отримання накладної'}
            disableClickOutside={true}
            content={
                <ChangeNakladnaForm
                    supplyBillBd={supplyBill}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default ChangeNakladnaButton